<template>
  <div class="main">
    <mt-header class="dl_header_new_bg" fixed>
      <mt-button slot="left" @click="goback">
         <img class="go-back"  src="@/assets/img/ico_back.png"/>
      </mt-button>
    </mt-header>
    <h2 class="page-title">{{ $t('my.onequan') }}</h2>
    <div class="container">
      <div class="container-detail">
        <div class="list" v-if="info">
          <div class="item" v-for="(item, index) in info.list.data" :key="index">
            <div class="avatar">
              <img v-if="item.avatarUrl" :src="item.avatarUrl" />
            </div>
            <div class="info">
              <div>
                {{item.nickname}} <br />
                <span style="color: #999999;font-size: 14px;">{{item.accid}}</span>
              </div>
              <div class="time">
                {{item.regTime | formatTime}}
              </div>
            </div>
          </div>
        </div>
        <div v-if="info" style="text-align: center;font-size: 12px;padding-top: 24px;">
          {{ $t('my.total') }}: {{info.list.total}}
        </div>
      </div> 
    </div>    
  </div>
</template>

<script>
import { Toast } from "mint-ui";
import { httpGetOneQuanInfo } from "@/api/login";
import { formatTime } from "@/utils/index";
export default {
  name: "Huobi",
  components: { Toast },
  data() {
    return {
      info: {
        list: {
          data: [],
          total:0
        }
      },
      startId: ''
    };
  },
  created() {
    this.getInfo(1);
  },
  computed:{
    
  },
  methods: {
    goback: function() {
      window.history.length > 1 ? this.$router.go(-1) : this.$router.push("/");
    },
    getInfo(pageNo) {
      console.log('pageNo', pageNo);
      httpGetOneQuanInfo({
          pageNo: pageNo,
          startId: this.startId
        }).then((res) => {
          console.log('res', res);
          if(res){
            var dd = res.data.list.data;
            this.info.list.data.push(...dd);
            this.info.list.total = res.data.list.total;
            this.info.list.pageIndex = res.data.list.pageIndex;
            this.info.list.pageSize = res.data.list.pageSize;
            if(this.info.list.data.length > 0){
              this.startId = this.info.list.data.slice(-1).id
            }
          }
          
        }).catch((e) => {
        });
    },
  },
  watch: {
    
  },
  activated: function () {
    
  }
};
</script>

<style scoped>
* {
  box-sizing: border-box;
}
.main {
  width: 100%;
  height: 100%;
  background-color: #f6f8fa;
  padding: 60px 30px 0 !important;
}
.go-back{
  width: 20px;
  height: 20px;
}
.page-title{
  font-size: 1.5rem;
  margin-bottom:20px;
}
.container {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;

}
.container-detail {
  width: 100%;
  background-color: #fff;
  padding: 20px;
  border-radius: 10px;
  margin-top: 20px;
  box-shadow: 0 20px 15px 8px #DAE5F0;
}
.container img{
  width: 40px;
  height: auto;
}
.swiper {
  box-sizing: border-box;
  color: #828590;
  box-sizing: border-box;
  margin-left: 10px;
}
.swiper p {
  font-size: 0.75rem;
  margin: 5px;
  font-weight: 400;
}
.main /deep/ .mint-cell{
  border-bottom: 1px solid #E4E9EE !important;
}
.main /deep/ .mint-cell:last-child{
  border:none !important;
}
.list {

}
.list .item{
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.list .item .avatar{
  width: 40px;
  height: 40px;
  border-radius: 8px;
  background: #f3f3f3;
  overflow: hidden;
}
.list .item .avatar img{
  border-radius: 8px;
}
.list .item .info{
  width: calc(100% - 60px);
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.time{
  font-size: 12px;
  color: #999999;
}
</style>

